<template>
    <div class="pkg-content">
        <div class="msg">
            <el-card class="box-card card1">
                <div class="search">
                    <el-button @click="goBack()">返回</el-button>
                    <el-button v-show="!isView" @click="save()" type="primary">保存</el-button>
                    <el-button v-show="!isView" @click="publish()" type="primary">发布</el-button>
                    <el-button v-show="isView && (themeStatus === '10' || themeStatus === '30')" type="primary" @click="goEdit">编辑</el-button>
                    <el-button v-show="isView && (themeStatus === '10' || themeStatus === '30')" @click="publish()" type="primary">发布</el-button>
                    <el-button v-show="isView && themeStatus === '20'" type="primary" @click="soldOut">下架</el-button>
                </div>
            </el-card>
        </div>
        <!-- 基本信息 -->
        <div class="msg">
            <el-card class="box-card">
                <div slot="header" class="clearfix">
                    <span>基本信息</span>
                </div>
                <div>
                    <el-form
                            label-position="top"
                            :model="formData.managedata"
                            :rules="dataRule"
                            ref="dataForm">
                        <el-form-item prop="themeTitle" label="话题名称">
                            <el-row>
                                <el-col :span="17">
                                    <el-input v-model="formData.managedata.themeTitle"
                                              :maxlength="50"
                                              placeholder="请输入话题名称，最多50字"
                                              :disabled="isView"
                                              show-word-limit></el-input>
                                </el-col>

                            </el-row>
                        </el-form-item>
                        <el-form-item prop="themeIntro" label="话题简介">
                            <el-row>
                                <el-col :span="17">
                                    <el-input type="textarea"
                                              v-model="formData.managedata.themeIntro"
                                              :maxlength="500"
                                              placeholder="请输入话题简介，最多500字"
                                              :disabled="isView"
                                              auto-height
                                              show-word-limit
                                              @input="descInput"></el-input>
                                </el-col>
                            </el-row>
                        </el-form-item>
                        <el-form-item prop="fileUrl" label="话题配图">
                            <el-upload class="upload-demo"
                                       :headers="headers"
                                       :action="actionUrl"
                                       accept=".jpg,.png,.jpeg"
                                       :on-success="uploadSuccess"
                                       :show-file-list="false"
                                       :disabled="isView"
                                       :beforeUpload="beforeAvatarUpload">
                                <div class="media-warpper">
                                    <div v-if="formData.managedata.fileUrl">
                                        <img alt="" :src="formData.managedata.fileUrl">
                                    </div>
                                    <em v-else class="el-icon-plus avatar-uploader-icon"></em>
                                    <div v-if="!formData.managedata.fileUrl" class="el-upload__text" style="width: 100%;color: #b5b5b5">点击上传图片</div>
                                    <div v-if="formData.managedata.fileUrl && !isView " class="remove-icon" @click.stop="removeImg">
                                        <em class="el-icon-close"></em>
                                    </div>
                                </div>
                            </el-upload>
                            <div >建议尺寸比例5.72:1，如比例为其他，系统则只截取中间部分<br>不超过4M，格式为png,jpeg及jpg</div>
                        </el-form-item>
                        <!-- 品牌 -->
                        <el-form-item prop="brandsList">
                            <span style="color:#F56C6C;margin-right: 4px;">*</span>
                            <span style="margin-right: 10px;font-weight:400">所属品牌</span>
                            <el-tooltip placement="bottom-start" effect="light" >
                                <div slot="content">所属品牌只有“未发布”状态下可以修改。</div>
                                <em class="el-icon-question" style="color: #1C69D3; margin-right: 10px"></em>
                            </el-tooltip>
                            <el-row>
                                <el-col :span="15">
                                    <el-checkbox-group v-model="formData.managedata.brandsList">

                                            <el-checkbox v-for="(brand, index) in brands" :label="brand.code"  disabled
                                                :key="index" >{{brand.name}}</el-checkbox>
                                    </el-checkbox-group>

                                    <!-- <el-checkbox-group v-model="brandsList">
                                        <el-checkbox v-for="(brand, index) in brands" :label="brand.code" :disabled="!isSelectBrand"
                                            :key="index" >{{brand.name}}</el-checkbox>
                                    </el-checkbox-group> -->
                                </el-col>
                            </el-row>
                        </el-form-item>

                        <!--所属分组-->
                        <el-form-item prop="groupType">
                            <span style="color:#F56C6C;margin-right: 4px;">*</span>
                            <span style="margin-right: 10px;font-weight:400">所属分组</span>
                            <el-tooltip placement="bottom-start" effect="light" >
                                <div slot="content">所属分组只有“未发布”状态下可以修改。</div>
                                <em class="el-icon-question" style="color: #1C69D3; margin-right: 10px"></em>
                            </el-tooltip>
                            <el-row>
                                <el-col :span="8">
                                    <el-select v-model="formData.managedata.groupType" placeholder="请选择" :disabled="isView">
                                        <el-option v-for="(item,index) in groupOption"
                                                   :key="index"
                                                   :label="item.dictName"
                                                   :value="item.dictValue">
                                        </el-option>
                                    </el-select>
                                </el-col>
                            </el-row>
                        </el-form-item>

                        <el-form-item prop="caregoryId" label="话题分类">
                            <el-row>
                                <el-col :span="8">
                                    <el-select v-model="formData.managedata.caregoryId" placeholder="请选择" :disabled="isView">
                                        <template v-for="classify in classifyList">
                                            <el-option :key="classify.classifyId" :label="classify.classifyName" :value="classify.classifyId"></el-option>
                                        </template>
                                    </el-select>
                                </el-col>
                            </el-row>
                        </el-form-item>



                        <el-form-item prop="tags" label="标签">
                            <div>
                                <el-tag
                                        style="margin-bottom: 5px"
                                        :key="tag.tagContent + index"
                                        v-for="(tag, index) in formData.managedata.tags"
                                        :closable="!isView"
                                        :disable-transitions="false"
                                        @close="handleClose(tag)">
                                    {{tag.tagContent}}
                                </el-tag>
                                <el-input
                                        v-if="!isView"
                                        style="width: 200px;margin-bottom: 5px"
                                        class="input-new-tag"
                                        v-model="inputValue"
                                        placeholder="请输入标签"
                                        @keyup.enter.native="handleInputConfirm"
                                        @blur="handleInputConfirm"
                                >
                                </el-input>
                            </div>
                            <el-tag
                                    :key="tempTag.id"
                                    v-for="tempTag in tempTags"
                                    :closable="!isView"
                                    :disable-transitions="false"
                                    @close="handleClose2(tempTag)">
                                {{tempTag.name}}
                            </el-tag>
                        </el-form-item>

                         <!--嘉宾-->
                        <el-form-item prop="guestId" label="嘉宾" >
                            <!--发起人-->
                            <div v-if="initiatorTag" style="padding: 10px 0;width: 125%;">
                                <el-tag
                                        style="margin: 3px;"
                                        :key="user.userId"
                                        v-for="user in usersCon"
                                        :closable="!isView"
                                        :disable-transitions="false"
                                        v-if="user.userType === '2'">
                                        {{user.userName+"（"+user.userCode+"）"}}
                                </el-tag>
                            </div>
                            <!--虚线-->
                            <div v-if="guestDashed" style="border-top: 1px dashed #DCDCDC;width: 125%;"/>
                            <!--嘉宾-->
                            <div v-if="guesTag" style="padding: 10px 0;width: 125%;">
                                <el-tag
                                        style="margin: 3px;"
                                        :key="user.userId"
                                        v-for="user in usersCon"
                                        :closable="!isView"
                                        :disable-transitions="false"
                                        v-if="user.userType === '1'">
                                    {{user.userName+"（"+user.userCode+"）"}}
                                </el-tag>
                            </div>
                        </el-form-item>
                    </el-form>
                </div>
            </el-card>
        </div>
        <!-- 话题补充说明 -->
        <div class="msg">
            <el-card class="box-card">
                <div slot="header" class="clearfix">
                    <span>话题补充说明</span>
                </div>
                <div class="introduce-container">
                    <div class="introduce-list">
                        <template v-for="(introduce, index) in introduceList">
                            <div :key="index" class="introduce-item">
                                <template v-if="introduce.introduceType == '10'">
                                    <el-row>
                                        <el-col :span="10" class="content">
                                            <el-input type="textarea" v-model="introduce.introduceContent" :maxlength="500"  placeholder="请输入文本，最多500字" show-word-limit :disabled="isView"></el-input>
                                            <em v-if="!isView" class="el-icon-remove remove-icon" @click="delIntroduce(index)"></em>
                                        </el-col>
                                    </el-row>
                                </template>
                                <template v-else-if="introduce.introduceType == '20'">
                                    <div class="media-warpper content">
                                        <img alt="" :src="introduce.introduceContent">
                                        <em v-if="!isView" class="el-icon-remove remove-icon" @click="delIntroduce(index)"></em>
                                    </div>
                                </template>
                                <template v-else-if="introduce.introduceType == '30'">
                                    <div style="display: flex;">
                                        <div class="media-warpper content">
                                            <video :src="introduce.introduceContent" controls/>
                                            <em v-if="!isView" class="el-icon-remove remove-icon" @click="delIntroduce(index)"></em>
                                        </div>
                                        <div class="media-warpper content1" >
                                            <img alt="" :src="introduce.videoHeadUrl">
                                        </div>
                                    </div>
                                </template>
                            </div>
                        </template>
                    </div>
                    <div v-if="!isView" class="bottom-btns">
                        <em class="el-icon-circle-plus" @click="addText">添加文本</em>
                        <em class="el-icon-circle-plus" @click="addImage">添加图片</em>
                        <em class="el-icon-circle-plus" @click="addVideo">添加视频</em>
                    </div>
                    <br>
                    <div v-if="!isView">
                        文本不能超过500字,图片不能大于4MB,视频不能超过500MB
                    </div>
                </div>
                <el-upload
                        ref="introduce-img"
                        :headers="headers"
                        :action="actionUrl"
                        accept=".jpg,.png,.jpeg"
                        :on-success="introduceImgUploadSuccess"
                        :show-file-list="false"
                        :beforeUpload="beforeImgUpload">
                </el-upload>
                <el-upload
                        ref="introduce-video"
                        :headers="headers"
                        :action="actionUrl"
                        accept=".mp4, .mov"
                        :show-file-list="true"
                        :beforeUpload="beforeVideoUpload"
                        :on-success="introduceVideoUploadSuccess">
                </el-upload>
            </el-card>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue'
    export default {
        name: "creationSharingShow",
        data() {
            return {
                themeStatus: "",
                remnant: 0,
                // 上传地址
                actionUrl: window.SITE_CONFIG['apiBaseURL'] + '/sys/config/imgUpload',
                type: null,
                formData:{
                    managedata:{
                        themeId: null,
                        themeTitle: "", //话题名称
                        themeIntro: "", //话题简介
                        fileName: "", //文件名称
                        fileUrl: "", //文件路径
                        caregoryId: null, //话题分类
                        tags: [],   //标签集合
                        brandsList:[],
                        groupType: null, //所属分组
                        guestId: "", //嘉宾
                    },
                },
                status: null,
                dataRule: {
                    themeTitle: [
                        { required: true, message: "请输入话题名称，最多50字", trigger: 'blur' },
                    ],
                    fileUrl: [
                        { required: true, message: "请上传话题配图", trigger: 'change' }
                    ],
                    caregoryId: [
                        { required: true, message: "请选择话题分类", trigger: 'change' }
                    ],
                    groupType: [
                        { required: true, message: "请选择所属分组", trigger: 'change' }
                    ],
                    themeIntro: [
                        { required: true, message: "请输入话题简介，最多500字", trigger: 'blur' }
                    ],
                    tags: [
                        { required: true, message: "请输入标签", trigger: 'change', type: "array" }
                    ],
                    brandsList: [
                        { required: true, message: "请勾选品牌", trigger: 'change', type: "array" }
                    ]
                },
                //分类集合
                classifyList: [],
                //话题介绍集合
                introduceList: [],
                //话题介绍下标
                introduceIndex: null,
                //标签相关
                tempTags: [],
                inputValue: '',

                // 所属分组
                groupOption: [],
                // 品牌
                brands:[],

                isInitBrand:false,
                usersCon: [],
                initiatorTag: false,// 嘉宾的发起人部分
                guestDashed: false,// 嘉宾的虚线
                guesTag: false,// 嘉宾的嘉宾部分
            }
        },
        computed:{
            //是否为新增
            isAdd(){
                return this.type == "add"
            },
            //是否为查看
            isView(){
                return this.type == "view"
            },
            // 获取请求头
            headers: function headers () {
                let headersObj = {
                    token: Vue.prototype.getStorage(Vue.prototype.GLOBAL.TOKEN)
                }
                return headersObj
            }
        },
        // 生命周期 - 挂载完成（可以访问DOM元素）
        activated() {
            this.type = this.$route.query.type
            this.formData.themeId = this.$route.query.id
            this.getClassifyList()
            this.getGroupType()
            this.getInfo()
        },
        mounted() {
            console.log('mounted')
        },
        methods: {

            //下架
            soldOut(){
                this.singleActionHandler("下架", "/grow/theme/soldOut", this.formData.managedata)
            },

            //单数据操作处理
            singleActionHandler(actionName, api, data){
                this.$confirm(`是否${actionName}该话题？`, `${actionName}话题`, {
                    type: 'warning'
                }).then(() => {
                    this.$request.post(`${api}/${data.themeId}`).then( r => {
                        this.$message({
                            message: `${actionName}成功`,
                            type: 'success',
                            duration: 500,
                            onClose: () => {
                                this.introduceList = []
                                this.$refs["dataForm"].resetFields()
                                this.$router.go(-1)
                            }
                        })
                    })
                }).catch((err) => {
                    console.log(err)
                })
            },

            goEdit() {
                var type = "edit"
                var id = this.formData.managedata.themeId
                // this.type = "edit"
                this.$router.push({
                    name: "grow-theme-themeAddOrUpdate",
                    query: {
                        type,
                        id
                    }
                })
                this.$store.state.contentTabs.splice(this.$store.state.contentTabs.findIndex(item => item.path === this.$route.path), 1)

            },

            descInput(){
                var txtVal = this.formData.themeIntro.length;
                this.remnant = txtVal;
            },
            /**
             * 标签相关
             */
            handleClose(tag) {
                this.formData.managedata.tags.splice(this.formData.managedata.tags.indexOf(tag), 1);
                this.$forceUpdate();
            },
            handleClose2(tempTag) {
                this.tempTags.splice(this.tempTags.indexOf(tempTag), 1);
                this.$forceUpdate();
            },
            handleInputConfirm() {
                let inputValue = {
                    tagContent: '',
                }
                inputValue.tagContent = this.inputValue;
                if (inputValue.tagContent) {
                    if(inputValue.tagContent.charAt(0) !== '#') {
                        inputValue.tagContent = '#' + inputValue.tagContent
                    }
                    this.formData.managedata.tags.push(inputValue)
                }
                this.inputValue = '';
            },
            //查询分类集合
            getClassifyList(){
                this.$request.get("/grow/themeClassify/list").then( r => {
                    this.classifyList = r
                })
            },
            //查询分类集合
            getGroupType(){
                this.$request.post("/grow/theme/getgrouptype").then( r => {
                    this.groupOption = r
                    this.groupOption.forEach(item => {
                        item.dictValue = item.dictValue+''
                    })
                })
            },
            // 查询详情数据
            getInfo() {
                //清空表单
                console.log(2, this.formData)
                if(this.isAdd){
                    //新增不访问接口
                    return
                }else {
                    this.formData.managedata.themeTitle = ''
                    this.formData.managedata.themeIntro = ''
                    this.formData.managedata.fileName = ''
                    this.formData.managedata.fileUrl = ''
                    this.formData.managedata.caregoryId = null
                    this.formData.managedata.tags = []
                    this.formData.introduceList = []
                    this.formData.managedata.brandsList = []
                    this.themeStatus = ""
                    this.usersCon = []
                }
                this.$request
                    .get(`/grow/theme/getDetail/${this.formData.themeId}`)
                    .then((res, total, code, data) => {
                        //console.log(data);
                        Object.getOwnPropertyNames(this.formData.managedata).forEach(key => {
                            let val = data.data.managedata[key]
                            val && (this.formData.managedata[key] = val)
                        })
                        this.formData.managedata.brandsList = [];

                        for(var i = 0; i < data.data.managedata.brandsList.length; i++) {
                            this.formData.managedata.brandsList.push(data.data.managedata.brandsList[i]);
                        }


                        this.themeStatus = data.data.managedata.themeStatus

                        // 话题补充图片水印
                        this.introduceList = data.data.introduceList

                        this.formData.managedata.tags = data.data.tags
                        this.usersCon=data.data.guest
                        this.usersCon.forEach(item=>{
                            if (item.userType==='2'){
                                this.initiatorTag = true
                            }else if (item.userType==='1'){
                                this.guesTag = true
                            }
                        })
                        if (this.initiatorTag && this.guesTag) {
                            this.guestDashed = true
                        }
                        console.log("data.data==============================")

                        if(this.isInitBrand == false){
                            var brandArr = this.enums['brandCode'];
                            try{
                                for(var i = 0; i < brandArr.length; i++){
                                    if(brandArr[i].code){
                                        this.brands.push(brandArr[i]);
                                    }
                                }
                                this.isInitBrand = true;

                            }
                            catch(e) {
                                console.log(e.message);
                            }
                        }
                    })
                    .catch((err) => {
                        console.log(err)
                    })
            },
            //保存
            save(status){
                //检查话题名称是否有未填写情况
                if(this.introduceList.find(item => !item.introduceContent)){
                    this.$message.warning("请检查话题补充说明必填项！")
                    return
                }
                this.$refs['dataForm'].validate((valid) => {
                    if (valid) {
                        //验证通过
                        let params = {
                            tags: this.formData.managedata.tags,
                            ...this.formData,
                            themeStatus: status,
                            introduceList: this.introduceList,
                            guest: this.usersCon
                        }
                        var _guestids = []
                        if (this.usersCon && this.usersCon.length > 0) {
                            this.usersCon.forEach(v=>{
                                _guestids.push(v.userId)
                            })
                        }
                        if (_guestids.length>0) {
                            this.$request.post(`/grow/basicuserinfo/getJobStatusByUserIds`, _guestids).then((res, total, code, data) => {
                                if (data.data.no.length > 0) {
                                    this.$confirm(`该话题下有离职的嘉宾，请确认是否清除离职嘉宾并提交`, '确认', {
                                        type: 'question'
                                    }).then(() => {
                                        this.saveApi(params)
                                    })
                                }else {
                                    this.saveApi(params)
                                }
                            })
                        }else {
                            this.saveApi(params)
                        }

                    }
                })
            },
            saveApi(params){
                this.$request.post(`/grow/theme/addOrUpdate`, params).then((res, total, code, data) => {
                    this.$message({
                        message: "保存成功",
                        type: 'success',
                        duration: 500,
                        onClose: () => {
                            this.goBack()
                        }
                    })
                }).catch(this.isSave = false)
            },
            //发布
            publish(){
                this.$confirm(`确认保存并发布该条话题?`, '保存并发布', {
                    type: 'question'
                }).then(() => {
                    this.save("20")
                }).catch((err) => {
                    console.log(err)
                })
            },
            // 返回
            goBack() {
                this.introduceList = []
                this.$refs["dataForm"].resetFields()
                this.formData.managedata.fileUrl=''
                this.formData.managedata.fileName=''
                // this.$router.go(-1)
                this.$router.push({
                    name: "grow-theme-themeManage"
                })
                this.$store.state.contentTabs.splice(this.$store.state.contentTabs.findIndex(item => item.path === this.$route.path), 1)
            },
            handleAvatarSuccess(res, file) {
                console.log(res)
                console.log(file)
                this.imageUrl = URL.createObjectURL(file.raw);
            },
            // //文件上传的校验
            beforeAvatarUpload (file) {
                let testmsg = file.name.substring(file.name.lastIndexOf('.') + 1)
                let uploadFormat = ['jpg', 'png', 'jpeg', 'JPG', 'PNG', 'JPEG']
                let falg = uploadFormat.indexOf(testmsg)
                if (falg === -1) {
                    this.$message.warning('只能上传jpg/png/jpeg文件')
                    return false
                }
                // 上传文件限制5M
                let isLt2M = file.size / 1024 / 1024 <= 4
                if (!isLt2M) {
                    this.$message.warning('上传文件大小不能超过4MB!')
                    return false
                }
            },
            //上传成功回调
            uploadSuccess (response, file) {
                if (response && response !== '') {
                    this.formData.managedata.fileName = file.name
                    this.formData.managedata.fileUrl = response.data
                }
            },
            //删除图片
            removeImg(){
                this.formData.managedata.fileName = null
                this.formData.managedata.fileUrl = null
            },
            //添加文本
            addText(){
                this.introduceList.push(new Introduce("10"))
            },
            addImage(){
                this.$refs['introduce-img'].$children[0].$refs.input.click()
            },
            addVideo(){
                this.$refs['introduce-video'].$children[0].$refs.input.click()
            },

            //话题介绍图片上传
            introduceImgUploadSuccess(response){
                this.introduceList.push(new Introduce("20", response.data))
            },
            beforeImgUpload(file) {
                let testmsg = file.name.substring(file.name.lastIndexOf('.') + 1)
                let uploadFormat = ['jpg', 'png', 'jpeg', 'JPG', 'PNG', 'JPEG']
                let falg = uploadFormat.indexOf(testmsg)
                if (falg === -1) {
                    this.$message.warning('只能上传jpg/png/jpeg文件')
                    return false
                }
                let isLt2M = file.size / 1024 / 1024 <= 20
                if (!isLt2M) {
                    this.$message.warning('上传图片大小不能超过20MB!')
                    return false
                }
            },

            //话题介绍视频上传
            introduceVideoUploadSuccess(response){
                this.introduceList.push(new Introduce("30", response.data))
            },
            beforeVideoUpload(file) {
                let testmsg = file.name.substring(file.name.lastIndexOf('.') + 1)
                let uploadFormat = ['mp4', 'mov', 'MP4', 'MOV']
                let falg = uploadFormat.indexOf(testmsg)
                if (falg === -1) {
                    this.$message.warning('只能上传mp4/mov格式视频')
                    return false
                }
                let isLt2M = file.size / 1024 / 1024 <= 1000
                if (!isLt2M) {
                    this.$message.warning('上传视频大小不能超过1G!')
                    return false
                }
            },
            //删除话题介绍
            delIntroduce(index){
                this.introduceList.splice(index, 1)
            },
        }
    }

    //话题介绍对象
    function Introduce(type, content){
        this.introduceType = type
        this.introduceContent = content
    }
</script>

<style lang="scss" scoped>

    .gray{
        margin-bottom: 16px !important;
    }
    .el-form-item{
        margin-bottom: 16px !important;
    }
    .search {
        text-align: right;
        margin-bottom: 0px;
    }

     .card1 .el-card__body {
        padding-top: 10px;
        padding-bottom: 10px;
    }

    .pkg-content {
        background-color: #f9f9f9;
        position: relative;
    }

    .msg {
        margin: 0 50px;
        padding: 10px 0;
        position: relative;
    }

    .msg span {
        font-weight: 600;
        margin-right: 20px;
    }

    pre {
        white-space: normal;
        white-space: -moz-pre-wrap;
        white-space: -pre-wrap;
        white-space: -o-pre-wrap;
        word-wrap: break-word;
        font-family: BMWGlobalProReg, "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
        font-size: 14px;
    }

    .introduce-list{
        margin-top: 20px;
        .introduce-item{

            .content{
                overflow: visible;
                position: relative;
                .remove-icon{
                    position: absolute;
                    right: -40px;
                    top: 5px;
                    z-index: 999999;
                    cursor: pointer;
                    font-size: 24px;
                    background-color: unset;
                    color: red;
                }
            }
            .content::before{
                content: "*";
                position: absolute;
                left: -12px;
                top: 50%;
                transform: translateY(-50%);
                color: red;
            }
            .content1::before{
                position: absolute;
                left: -12px;
                top: 50%;
                transform: translateY(-50%);
                color: red;
            }
            .content1 {
                margin-left: 5px;
            }
            margin-bottom: 20px;
        }
    }
    .media-warpper{
        position: relative;
        width: 220px;
        height: 100px;
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        justify-content: center;
        border: solid 1px #e0e3e9;
        border-radius: 5px;
        overflow: hidden;
        .avatar-uploader-icon{
            font-size: 50px;
            color: #b5b5b5;
        }
        *{
            max-width: 100%;
            max-height: 100%;
        }
        .remove-icon{
            position: absolute;
            top: 0px;
            right: 0;
            background: #dfdfdf;
            padding: 0 8px;
        }
    }
    .bottom-btns{
        >*{
            cursor: pointer;
            margin-right: 20px;
            display: inline-flex;
            align-items: center;
        }
        >*::before{
            color: #67d58d;
            font-size: 22px;
            transform: translateY(1px);
            margin-right: 5px;
        }
    }
    // textarea字数提示
     .el-input__count{
        font-size: 12px !important;
    }

</style>
